export default __webpack_public_path__ + "99e3869.png";